import axios from 'axios';

import { env } from 'config';
import { NspkDetails } from 'types';

const url = `${env.publicApiUrl}/v1/order-requisites`;

const getNspkDetails = async (orderId: string): Promise<NspkDetails> =>
  (await axios.get(`${url}/${orderId}/nspk-details`)).data;

export const orderRequisitesApi = {
  getNspkDetails,
};
